import { TFunction } from 'i18next'
import { RequestDisplayStatus } from './calculateRequestDuration'

export const getRequestStatusLabel = (status: RequestDisplayStatus, t: TFunction<'requests'>): string =>
  t(`table-column.status.${status}`)
